import React, { useEffect } from "react";
import { useState } from "react";
import { Button, CircularProgress, TextField } from "@mui/material";

function ExpertDetails({
  verifying = false,
  data,
  updateProfile,
  setUserStep,
  index,
  setIndex,
  selectedType,
  setIndexNum,
  userType,
  setTypeIndex,
}) {
  const [other, setOther] = useState(false);
  const [otherExpertise, setOtherExpertise] = useState("");
  const [type, setType] = useState("");

  const [selectedOptionsData, setSelectedOptionsData] = useState([]);

  const [id, setId] = useState();

  useEffect(() => {
    other ? setOtherExpertise(otherExpertise) : setOtherExpertise("");
  }, [other]);
  const optionClickHandler = (id, optionValue) => {
    setSelectedOptionsData([id]);

    setId(id);
    optionValue === "Yes" && selectedType.admin_type_id === 1
      ? setType("collab")
      : setType("");

    if (optionValue === "Other" || optionValue === "Yes") {
      setOther((prev) => !prev);
    } else {
      setOther(false);
    }
  };

  const chipClickHandler = (id, optionValue) => {
    if (selectedOptionsData.includes(id)) {
      setSelectedOptionsData(selectedOptionsData.filter((o) => o !== id));
    } else {
      setSelectedOptionsData([...selectedOptionsData, id]);
    }

    if (optionValue === "Other" || optionValue === "Yes") {
      setOther((prev) => !prev);
    }
  };
  return (
    <>
      <div
        className="onboarding-step "
        style={{ padding: "1.5rem", color: "#CFCFCF" }}
      >
        {data.length ? (
          <>
            <div className="question-wrapper">
              <p
                style={{
                  margin: "20px 0 40px 0",
                  fontSize: "26px",
                  fontWeight: 700,
                  textAlign: "center",
                  color: "#CFCFCF",
                }}
              >
                {data[index]?.question}
              </p>

              {data[index]?.is_multiple ? (
                <div className="options-wrapper">
                  {data[index]?.options.map(({ name: value, id }, i) => {
                    return (
                      <div
                        key={i}
                        style={{
                          margin: 12,
                          padding: "1px",
                          background:
                            "linear-gradient(152.68deg, #FFFFFF 5.46%, rgba(255, 255, 255, 0) 32.84%, rgba(255, 255, 255, 0) 71.3%, #FFFFFF 100%)",
                          borderRadius: "11.6279px",
                        }}
                      >
                        <div
                          key={id}
                          onClick={() => chipClickHandler(id, value)}
                          className="options-chip"
                          style={{
                            margin: 0,
                            borderRadius: "11.6279px",
                            background: selectedOptionsData.includes(id)
                              ? "radial-gradient(99.17% 99.17% at 50% 50%, #DADADA 0%, #121212 100%)"
                              : "radial-gradient(99.17% 99.17% at 50% 50%, #434343 0%, #121212 100%)",

                            color: selectedOptionsData.includes(id)
                              ? "#272727"
                              : "#CFCFCF",

                            // border: selectedOptionsData.includes(id)
                            //   ? "1px solid #FF4A01"
                            //   : "1px solid #D2D2D2",
                          }}
                        >
                          {value}
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="options-wrapper client-numbers">
                  {data[index]?.options.map(({ name: value, id: i }) => {
                    return (
                      <div
                        key={i}
                        style={{
                          margin: 12,
                          width: "70%",
                          padding: "1px",
                          background:
                            "linear-gradient(152.68deg, #FFFFFF 5.46%, rgba(255, 255, 255, 0) 32.84%, rgba(255, 255, 255, 0) 71.3%, #FFFFFF 100%)",
                          borderRadius: "8px",
                        }}
                      >
                        <div
                          onClick={() => optionClickHandler(i, value)}
                          className="options-chip "
                          style={{
                            textAlign: "center",
                            margin: 0,

                            background:
                              id === i
                                ? "radial-gradient(99.17% 99.17% at 50% 50%, #DADADA 0%, #121212 100%)"
                                : "radial-gradient(99.17% 99.17% at 50% 50%, #434343 0%, #121212 100%)",

                            color: id === i ? "#272727" : "#CFCFCF",
                          }}
                        >
                          {value}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            {other && (
              <div style={{ marginTop: "16px" }}>
                <span style={{ fontSize: "1.2em" }}>
                  {type === "collab"
                    ? "Please enter brand name"
                    : "Please enter other method"}
                </span>
                <TextField
                  className="other-expertise"
                  label={type === "collab" ? "Brand name" : "Other method"}
                  onChange={(e) => setOtherExpertise(e.target.value)}
                  //   error={error.otherExpertise}
                  //   helperText={error.otherExpertise ? "Please enter other method" : " "}
                  //   disabled={verifying}s
                  style={{ margin: "0.5rem 0rem" }}
                  placeholder={type === "collab" ? "Ex. Brand" : "Ex. method"}
                  fullWidth
                  focused
                />
              </div>
            )}
          </>
        ) : (
          <div
            style={{
              padding: "0px",
              textAlign: "center",
              margin: "50% 50% 50% 44%",
            }}
          >
            <CircularProgress size={"3rem"} />
          </div>
        )}
      </div>

      <div className="request-footer-btn">
        <Button
          id="step-6-onboarding"
          disabled={
            selectedOptionsData.length === 1 && other
              ? otherExpertise.length
                ? false
                : true
              : selectedOptionsData.length
              ? false
              : true
          }
          onClick={() => {
            setType("");
            setOtherExpertise("");
            setSelectedOptionsData("");
            setOther(false);

            updateProfile(
              selectedType?.admin_type_id === 1
                ? "expert"
                : selectedType?.admin_type_id === 2
                ? "brand"
                : selectedType?.admin_type_id === 3
                ? "centre"
                : "customer",
              data[index]?.question_id,

              selectedOptionsData,
              otherExpertise
            );

            if (index === data.length - 1) {
              userType === "expert"
                ? setTypeIndex((prev) => prev + 1)
                : setUserStep(6);
            }
            if (index !== data.length - 1) {
              setIndex((prev) => prev + 1);
              setIndexNum((prev) => prev + 1);
            }
          }}
          fullWidth
          variant="contained"
          size="large"
          style={{
            padding: "16px 0",
            fontSize: "1em",

            background:
              selectedOptionsData.length === 1 && other
                ? otherExpertise.length
                  ? "linear-gradient(91.75deg, #FFFFFF 0.11%, #C4C4C4 100.1%)"
                  : "#383838"
                : selectedOptionsData.length
                ? "linear-gradient(91.75deg, #FFFFFF 0.11%, #C4C4C4 100.1%)"
                : "#383838",

            color:
              selectedOptionsData.length === 1 && other
                ? otherExpertise.length
                  ? "#FF4A01"
                  : "#232323"
                : selectedOptionsData.length
                ? "#FF4A01"
                : "#232323",
          }}
        >
          {verifying ? "Submitting..." : "Continue"}
        </Button>
      </div>
    </>
  );
}

export default ExpertDetails;
